import humanizeDuration from "humanize-duration"

const options = {
  units: ["h", "m"],
  delimiter: " and ",
  round: true,
}

export const duration = (seconds: number) => {
  return humanizeDuration(seconds * 1000, options)
}
